import config from "#src/config";
import { getTimeStringFromDate } from "#utils/timeFormatter";
import { find } from "es-toolkit/compat";
import { v1 as uuidv1 } from "uuid";
import { AnalyzeSpec } from "../Redux/reducers/analyze";

export function getAnalyzeSpec(
  stream,
  sampleType,
  measurementType,
  timeRangeStart,
  timeRangeEnd
) {
  return new AnalyzeSpec({
    id: uuidv1() as any,
    // @ts-expect-error legacy opshub typing
    timeRangeStart: getTimeStringFromDate(timeRangeStart, config.DATE_FORMAT),
    // @ts-expect-error legacy opshub typing
    timeRangeEnd: getTimeStringFromDate(timeRangeEnd, config.DATE_FORMAT),
    // @ts-expect-error legacy opshub typing
    sampleTypes: [sampleType],
    // @ts-expect-error legacy opshub typing
    measurementType: [measurementType],
    // @ts-expect-error legacy opshub typing
    streams: [stream.id],
  });
}

export function getStreamsWithName(bookmark, availableStreams) {
  const streamIds = bookmark.streams;
  const streamsWithName = streamIds.map((streamId) => {
    if (streamId) {
      return find(availableStreams, { id: streamId });
    }
  });

  return {
    ...bookmark,
    streams: streamsWithName,
  };
}
